<template>
    <section>
        <div class="row mx-0 mt-2">
            <div class="border menu-prinicipal br-10" style="width:410px;height: calc(100vh - 140px);">
                <div
                v-for="(menu, idx) in menus" :key="idx"
                class="row mx-0 d-middle border-bottom cr-pointer"
                style="height:60px;"
                @click="$router.push({ name: menu.ruta })"
                >
                    <div :class="`mx-2 px-1 h-80 br-5 ${menu.ruta==$route.name?'bg-gr-red':''}`" />
                    <i :class="`${menu.icon} f-22 text-gr-general`" />
                    <div class="col-9 tres-puntos f-15">
                        {{ menu.nombre }}
                    </div>
                    <i :class="`icon-angle-right f-18 ${menu.ruta==$route.name?'text-gr-red':''}`" />
                </div>
            </div>
            <div class="px-0 border col br-tl-10 menu-prinicipal ml-3" style="width: calc(100vw - 575px);">
                <!-- <component :is="activo" /> -->
                <router-view />
            </div>
        </div>
    </section>
</template>

<script>
export default {
    data(){
        return {
            activo: 'tipoTiendas',
            menus: [
                { nombre: 'Unidades de Medida', ruta: 'admin-vip.almacen.parametrizar.productos.unidades', icon: 'icon-ruler' },
                { nombre: 'Categorias', ruta: 'admin-vip.almacen.parametrizar.productos.categorias', icon: 'icon-format-list-bulleted-type' },
                { nombre: 'Etiquetas', ruta: 'admin-vip.almacen.parametrizar.productos.etiquetas', icon: 'icon-tag' },
            ]
        }
    }
}
</script>

<style lang="css" scoped>
.menu-prinicipal{
    /* height: calc(100vh - 135px); */
    background: #fff;
}
</style>
